import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client'; // @ts-expect-error module is untyped

import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
// @ts-expect-error module is untyped
import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import * as RequestStates from 'marketplace-ui-common/requestStates/RequestState';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { GET_PROVIDERS } from '../../../queries/providerFilterQuery';

const LoadingComponent = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  size: "extra-small"
});

const ProviderFilter = ({
  disabled,
  isUngatedForUnifiedSearch = false,
  offeringType = 'THEME',
  onChange,
  scrollable = true,
  value
}) => {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_PROVIDERS, {
    variables: {
      offeringType,
      isUngatedForUnifiedSearch
    }
  });
  const providersOptions = useMemo(() => {
    /* combine into one variable to make TS happy */
    const providersData = data || previousData;

    if (!providersData) {
      return [];
    }

    const {
      providers: {
        providerNames
      }
    } = providersData;

    if (!providerNames) {
      return [];
    }

    return providerNames.map(item => ({
      text: item,
      value: item
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [data, previousData]);
  const providerNamesRequestState = useMemo(() => {
    if (loading) {
      return RequestStates.PENDING;
    }

    if (error) {
      return RequestStates.FAILED;
    }

    if (!data && !previousData) {
      return RequestStates.UNINITIALIZED;
    }

    return RequestStates.SUCCEEDED;
  }, [data, error, loading, previousData]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    LoadingComponent: LoadingComponent,
    requestStatus: providerNamesRequestState,
    showLoadingOnUninitialized: true,
    children: /*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.providers.title'),
      disabled: disabled,
      multi: true,
      name: ThemeQueryField.PROVIDERS,
      onChange: onChange,
      options: providersOptions,
      scrollable: scrollable,
      value: value,
      virtualized: scrollable
    })
  });
};

export default ProviderFilter;